// extracted by css-extract-rspack-plugin
export default {"tableWrapper":"TEN67vd9fh0P9CDG"};